const NodeSpinner = ({ size = 14, className = '' }) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		className={className}
	>
		{/* Three nodes connected by edges, with a traveling pulse */}
		{/* Static edges */}
		<line x1="4" y1="12" x2="12" y2="4" stroke="currentColor" strokeOpacity="0.2" strokeWidth="1.5" />
		<line x1="12" y1="4" x2="20" y2="12" stroke="currentColor" strokeOpacity="0.2" strokeWidth="1.5" />
		<line x1="4" y1="12" x2="20" y2="12" stroke="currentColor" strokeOpacity="0.2" strokeWidth="1.5" />

		{/* Node 1 — left */}
		<circle cx="4" cy="12" r="2.5" fill="currentColor">
			<animate
				attributeName="opacity"
				values="1;0.2;0.2;1"
				dur="1.2s"
				repeatCount="indefinite"
			/>
		</circle>

		{/* Node 2 — top */}
		<circle cx="12" cy="4" r="2.5" fill="currentColor">
			<animate
				attributeName="opacity"
				values="0.2;1;0.2;0.2"
				dur="1.2s"
				repeatCount="indefinite"
			/>
		</circle>

		{/* Node 3 — right */}
		<circle cx="20" cy="12" r="2.5" fill="currentColor">
			<animate
				attributeName="opacity"
				values="0.2;0.2;1;0.2"
				dur="1.2s"
				repeatCount="indefinite"
			/>
		</circle>

		{/* Traveling pulse along edges */}
		<circle r="1.5" fill="hsl(24, 100%, 46%)">
			<animateMotion
				path="M4,12 L12,4 L20,12 L4,12"
				dur="1.2s"
				repeatCount="indefinite"
			/>
			<animate
				attributeName="opacity"
				values="0.9;1;0.9;0.9"
				dur="1.2s"
				repeatCount="indefinite"
			/>
		</circle>
	</svg>
);

export default NodeSpinner;
